import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useUser } from './useUser';

type UserProduct = {
  productId: number;
  userId: number;
  productCode: string;
  expiryDate: Date;
  product: {
    code: string;
    name: string;
    totalQuestions: number;
    color: string;
    description: string;
    examCompany: string;
    certificationImage: string;
    certificationImageWidth: number;
    certificationImageHeight: number;
    examName: string;
    isAdmin: boolean;
  };
};

export type ProductNotOwned = {
  id: number;
  code: string;
  name: string;
  totalQuestions: number;
  color: string;
  description: string;
  examCompany: string;
  certificationImage: string;
  certificationImageWidth: number;
  certificationImageHeight: number;
  examName: string;
  // somehow this is returned as a string wtf
  price: string;
};

type QueryReturnType = {
  userProducts: UserProduct[];
  productsNotOwned: ProductNotOwned[];
};

export const useGetUserProducts = (): UseQueryResult<QueryReturnType> => {
  const { data: user } = useUser();
  return useQuery<QueryReturnType>({
    queryKey: ['userProducts'],
    queryFn: async () => {
      const res = await axios.get('/api/auth/user-products');
      return res.data;
    },
    enabled: !!user,
    retry: false,
  });
};
